import { GetInvestigators, GetInvestigatorsResponse } from "@/api/dtos";
import { useGet } from "@ngt/opms";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";


export const INVESTIGATOR_LOOKUP_OTHER = "other";

const getData = (response?: SWRResponse<GetInvestigatorsResponse, GetInvestigatorsResponse>) => response?.data?.investigators;

const getError = (response?: SWRResponse<GetInvestigatorsResponse, GetInvestigatorsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useInvestigators = (institutionCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return institutionCode ?
            () => {
                return new GetInvestigators({ institutionCode });
            } :
            undefined;
    }, [institutionCode])

    return useGet(request, { getData, getError }, configuration);
};

export default useInvestigators;